import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { NAV_LINKS, SERVICES, SITE, scrollToId } from "../../lib/site";

const Footer = () => {
    const go = (href) => (e) => {
        e.preventDefault();
        scrollToId(href);
    };

    return (
        <footer
            data-testid="site-footer"
            className="border-t border-gold/20 bg-emerald-900"
        >
            <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-20">
                <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
                    <div>
                        <div className="flex items-center gap-3">
                            <img
                                src="/logo.png"
                                alt="Flammingo Luxurious Spa logo"
                                className="h-12 w-12 rounded-full object-cover ring-1 ring-gold/50"
                            />
                            <span className="leading-none">
                                <span className="block font-serif text-lg tracking-[0.18em] text-cream">
                                    FLAMMINGO
                                </span>
                                <span className="block text-[10px] uppercase tracking-[0.42em] text-gold">
                                    Luxurious Spa
                                </span>
                            </span>
                        </div>
                        <p className="mt-6 max-w-xs text-sm font-light leading-relaxed tracking-wide text-sage/80">
                            A serene luxury wellness destination in Vashi, Navi
                            Mumbai — where relaxation, privacy and refined
                            service meet.
                        </p>
                    </div>

                    <nav aria-label="Footer">
                        <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
                            Explore
                        </h3>
                        <ul className="mt-6 space-y-3.5">
                            {NAV_LINKS.map((link) => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        onClick={go(link.href)}
                                        className="text-sm font-light tracking-wide text-sage/85 transition-colors duration-300 hover:text-gold"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <nav aria-label="Services">
                        <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
                            Experiences
                        </h3>
                        <ul className="mt-6 space-y-3.5">
                            {SERVICES.map((service) => (
                                <li key={service.slug}>
                                    <a
                                        href="#services"
                                        data-testid={`footer-service-${service.slug}`}
                                        onClick={go("#services")}
                                        className="text-sm font-light tracking-wide text-sage/85 transition-colors duration-300 hover:text-gold"
                                    >
                                        {service.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    <div>
                        <h3 className="text-[11px] font-medium uppercase tracking-[0.3em] text-gold">
                            Contact
                        </h3>
                        <ul className="mt-6 space-y-4 text-sm font-light tracking-wide text-sage/85">
                            <li className="flex items-start gap-3">
                                <MapPin size={15} className="mt-0.5 shrink-0 text-gold/70" aria-hidden="true" />
                                <span>
                                    {SITE.addressLine1}, Sector 19D,
                                    <br />
                                    {SITE.addressLine3}
                                </span>
                            </li>
                            <li className="flex items-start gap-3">
                                <Clock size={15} className="mt-0.5 shrink-0 text-gold/70" aria-hidden="true" />
                                {SITE.hours} · {SITE.days}
                            </li>
                            <li>
                                <a
                                    href={SITE.phoneHref}
                                    data-testid="footer-phone-link"
                                    className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
                                >
                                    <Phone size={15} className="shrink-0 text-gold/70" aria-hidden="true" />
                                    {SITE.phoneDisplay}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={SITE.phone2Href}
                                    data-testid="footer-phone2-link"
                                    className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
                                >
                                    <Phone size={15} className="shrink-0 text-gold/70" aria-hidden="true" />
                                    {SITE.phone2Display}
                                </a>
                            </li>
                            <li>
                                <a
                                    href={SITE.emailHref}
                                    data-testid="footer-email-link"
                                    className="flex items-start gap-3 break-all transition-colors duration-300 hover:text-gold"
                                >
                                    <Mail size={15} className="mt-0.5 shrink-0 text-gold/70" aria-hidden="true" />
                                    {SITE.email}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="border-t border-gold/15">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-[11px] uppercase tracking-[0.25em] text-sage/60 md:flex-row md:px-12">
                    <p data-testid="footer-copyright">
                        © 2026 Flammingo Luxurious Spa. All Rights Reserved.
                    </p>
                    <p>Vashi, Navi Mumbai</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
